<template>
  <v-card flat>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="types"
        :loading="loading"
        class="elevation-1"
        disable-pagination
        hide-default-footer
      >
        <template #[`item.value`]="{ item }">
          {{ formatCurrency(item.value, item.currency) }}
        </template>
        <template #[`item.durationDays`]="{ item }">
          <span v-if="item.durationDays">{{ item.durationDays }} dager</span>
          <span v-else>Ingen utløp</span>
        </template>
        <template #[`item.isActive`]="{ item }">
          <v-chip
            small
            :color="item.isActive ? 'green' : 'grey'"
            text-color="white"
          >
            {{ item.isActive ? "Aktiv" : "Inaktiv" }}
          </v-chip>
        </template>
        <template #[`item.actions`]="{ item }">
          <v-btn
            icon
            small
            @click="$emit('edit', item)"
          >
            <v-icon color="primary">
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-btn
            icon
            small
            @click="$emit('toggle-status', item)"
          >
            <v-icon color="grey darken-1">
              {{ item.isActive ? "mdi-eye-off" : "mdi-eye" }}
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { IGiftCardTypeDTO } from "@shared/types";
import { userModule } from "@/store/modules/user/userModule";

@Component({
  name: "gift-card-types-tab",
})
export default class GiftCardTypesTab extends Vue {
  @Prop({ required: true }) types!: IGiftCardTypeDTO[];
  @Prop({ default: false }) loading!: boolean;

  get headers() {
    return [
      { text: "Navn", value: "name" },
      { text: "Verdi", value: "value" },
      { text: "Valuta", value: "currency" },
      { text: "Varighet", value: "durationDays" },
      { text: "Status", value: "isActive" },
      { text: "Handlinger", value: "actions", sortable: false },
    ];
  }

  public formatCurrency(value: number, currency: string | undefined): string {
    const formatter = new Intl.NumberFormat(this.$i18n.locale, {
      style: "currency",
      currency: currency || userModule.user?.currency || "NOK",
    });
    return formatter.format(value);
  }
}
</script>
